export enum EnvironmentTypeEnum {
  'BACKOFFICE' = 'BACKOFFICE',
  'APP' = 'APP',
  'OWNER' = 'OWNER',
}
